import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    disconnected: Boolean,
    iframeSrc: String,
    boDomain: String,
    setSessionUrl: String
  }

  connect() {
    if(this.disconnectedValue) {
      this.doTimeout = true;
      const rM = this.rM.bind(this);
      window.addEventListener('message', rM, false);
      const iframe = document.createElement('iframe');
      iframe.src = this.iframeSrcValue;
      iframe.style = "width:0px;height:0px;border:none;";
      document.body.appendChild(iframe);
      setTimeout(() => {
        if(!this.doTimeout) { return; }
        window.removeEventListener('message', rM, false);
      }, 5000);
    }
  }

  rM(e) {
    if(e.origin === this.boDomainValue) {
      let data = JSON.parse(e.data)
      if(data.success && data.agent_token) {
        this.doTimeout = false
        const url = this.setSessionUrlValue
        fetch(url, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').content
          },
          body: JSON.stringify({
            agent_token: data.agent_token,
          })
        })
      } 
    }
  }
}